 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// LOGIN, SIGNUP & UPDATE USER ACTION-TYPES LOGISTIC.
export const AUTH_USER = 'AUTH_USER';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const AUTH_REGISTER_USER = 'AUTH_REGISTER_USER';
export const AUTH_REGISTER_START = 'AUTH_REGISTER_START';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAIL = 'AUTH_REGISTER_FAIL';

export const GO_TO_SIGN_IN = 'GO_TO_SIGN_IN';
export const GO_TO_SIGN_UP = 'GO_TO_SIGN_UP';
export const HANDLE_SIDEDRAWER = 'HANDLE_SIDEDRAWER';

export const AUTH_USER_FB = 'AUTH_USER_FB';
export const AUTH_USER_FB_START = 'AUTH_USER_FB_START';
export const AUTH_USER_FB_SUCCESS = 'AUTH_USER_FB_SUCCESS';
export const AUTH_USER_FB_FAIL = 'AUTH_USER_FB_FAIL';

export const UPDATE_USER_ADDRESS = 'UPDATE_USER_ADDRESS';
export const AUTH_USER_ADDRESS_START = 'AUTH_USER_ADDRESS_START';
export const AUTH_USER_ADDRESS_SUCCESS = 'AUTH_USER_ADDRESS_SUCCESS';
export const AUTH_USER_ADDRESS_FAIL = 'AUTH_USER_ADDRESS_FAIL';

export const UPDATE_USER = 'UPDATE_USER';
export const AUTH_USER_UPDATE_START = 'AUTH_USER_UPDATE_START';
export const AUTH_USER_UPDATE_SUCCESS = 'AUTH_USER_UPDATE_SUCCESS';
export const AUTH_USER_UPDATE_FAIL = 'AUTH_USER_UPDATE_FAIL';

export const AUTH_USER_CREDIT_CARD = 'AUTH_USER_CREDIT_CARD';
export const AUTH_USER_CREDIT_CARD_START = 'AUTH_USER_CREDIT_CARD_START';
export const AUTH_USER_CREDIT_CARD_SUCCESS = 'AUTH_USER_CREDIT_CARD_SUCCESS';
export const AUTH_USER_CREDIT_CARD_FAIL = 'AUTH_USER_CREDIT_CARD_FAIL';

export const AUTH_INIT_LOGOUT = 'AUTH_INIT_LOGOUT';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHECK_STATE = 'AUTH_CHECK_STATE';
export const AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCHING FOR DEPARTMENTS ACTION-TYPES LOGISTIC
export const CLEAR_DEPARTMENTS = 'CLEAR_DEPARTMENTS';

export const DEPARTMENTS_START = 'FETCH_DEPARTMENTS_START';
export const DEPARTMENTS_SUCCESS = 'FETCH_DEPARTMENTS_SUCCESS';
export const DEPARTMENTS_FAILED = 'FETCH_DEPARTMENTS_FAILED';
export const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';

export const DEPARTMENTS_BY_ID_SUCCESS = 'DEPARTMENTS_BY_ID_SUCCESS';
export const DEPARTMENTS_BY_ID_FAIL = 'DEPARTMENTS_BY_ID_FAIL';
export const FETCH_DEPARTMENTS_ID = 'FETCH_DEPARTMENTS_ID';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCHING FOR CATEGORIES ACTION-TYPES LOGISTIC
export const CLEAR_CATEGORIES = 'CLEAR_CATEGORIES';

export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const CATEGORIES_START = 'CATEGORIES_START';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_FAIL = 'CATEGORIES_FAIL';

export const FETCH_CATEGORY_ID = 'FETCH_CATEGORY_ID';
export const CATEGORY_ID_SUCCESS = 'FETCH_CATEGORY_ID_SUCCESS';
export const CATEGORY_ID_FAIL = 'FETCH_CATEGORY_ID_FAIL';

export const FETCH_CATEGORY_IN_DEPARTMENT = 'FETCH_CATEGORY_IN_DEPARTMENT';
export const CATEGORY_IN_DEPARTMENT_START = 'CATEGORY_IN_DEPARTMENT_START';
export const CATEGORY_IN_DEPARTMENT_SUCCESS = 'CATEGORY_IN_DEPARTMENT_SUCCESS';
export const CATEGORY_IN_DEPARTMENT_FAIL = 'CATEGORY_IN_DEPARTMENT_FAIL';

export const FETCH_CATEGORY_IN_PRODUCT = 'FETCH_CATEGORY_IN_PRODUCT';
export const CATEGORY_IN_PRODUCT_START = 'CATEGORY_IN_PRODUCT_START';
export const CATEGORY_IN_PRODUCT_SUCCESS = 'CATEGORY_IN_PRODUCT_SUCCESS';
export const CATEGORY_IN_PRODUCT_FAIL = 'CATEGORY_IN_PRODUCT_FAIL';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCHING FOR ATTRIBUTES ACTION-TYPES LOGISTIC
export const FETCH_ATTRIBUTES = 'FETCH_ATTRIBUTES';
export const FETCH_ATTRIBUTES_START = 'FETCH_ATTRIBUTES_START';
export const FETCH_ATTRIBUTES_SUCCESS = 'FETCH_ATTRIBUTES_SUCCESS';
export const FETCH_ATTRIBUTES_FAIL = 'FETCH_ATTRIBUTES_FAIL';

export const FETCH_ATTRIBUTES_ID = 'FETCH_ATTRIBUTES_ID';
export const FETCH_ATTRIBUTES_ID_SUCCESS = 'FETCH_ATTRIBUTES_ID_SUCCESS';
export const FETCH_ATTRIBUTES_ID_FAIL = 'FETCH_ATTRIBUTES_ID_FAIL';

export const ATTRIBUTES_VALUES_ID = 'ATTRIBUTES_VALUES_ID';
export const ATTRIBUTES_VALUES_ID_START = 'ATTRIBUTES_VALUES_ID_START';
export const ATTRIBUTES_VALUES_ID_SUCCESS = 'ATTRIBUTES_VALUES_ID_SUCCESS';
export const ATTRIBUTES_VALUES_ID_FAIL = 'ATTRIBUTES_VALUES_ID_FAIL';

export const ATTRIBUTES_IN_PRODUCT = 'ATTRIBUTES_IN_PRODUCT';
export const ATTRIBUTES_IN_PRODUCT_START = 'ATTRIBUTES_IN_PRODUCT_START';
export const ATTRIBUTES_IN_PRODUCT_SUCCESS = 'ATTRIBUTES_IN_PRODUCT_SUCCESS';
export const ATTRIBUTES_IN_PRODUCT_FAIL = 'ATTRIBUTES_IN_PRODUCT_FAIL';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCH FOR PRODUCTS ACTION-TYPES LOGISTIC
export const PRODUCTS_START = 'PRODUCTS_START';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_FAIL = 'PRODUCTS_FAIL';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';

export const PRODUCTS_NEXT_START = 'PRODUCTS_NEXT_START';
export const PRODUCTS_NEXT_SUCCESS = 'PRODUCTS_NEXT_SUCCESS';
export const PRODUCTS_NEXT_FAIL = 'PRODUCTS_NEXT_FAIL';
export const PRODUCTS_NEXT = 'PRODUCTS_NEXT';

export const PRODUCTS_PREV_START = 'PRODUCTS_PREV_START';
export const PRODUCTS_PREV_SUCCESS = 'PRODUCTS_PREV_SUCCESS';
export const PRODUCTS_PREV_FAIL = 'PRODUCTS_PREV_FAIL';
export const PRODUCTS_PREV = 'PRODUCTS_PREV';

export const PRODUCTS_IN_DEPARTMENT_NEXT = 'PRODUCTS_IN_DEPARTMENT_NEXT';
export const PRODUCTS_IN_DEPARTMENT_NEXT_START = 'PRODUCTS_IN_DEPARTMENT_NEXT_START';
export const PRODUCTS_IN_DEPARTMENT_NEXT_SUCCESS = 'PRODUCTS_IN_DEPARTMENT_NEXT_SUCCESS';
export const PRODUCTS_IN_DEPARTMENT_NEXT_FAIL = 'PRODUCTS_IN_DEPARTMENT_NEXT_FAIL';

export const PRODUCTS_IN_DEPARTMENT_PREV = 'PRODUCTS_IN_DEPARTMENT_PREV';
export const PRODUCTS_IN_DEPARTMENT_PREV_START = 'PRODUCTS_IN_DEPARTMENT_PREV_START';
export const PRODUCTS_IN_DEPARTMENT_PREV_SUCCESS = 'PRODUCTS_IN_DEPARTMENT_PREV_SUCCESS';
export const PRODUCTS_IN_DEPARTMENT_PREV_FAIL = 'PRODUCTS_IN_DEPARTMENT_PREV_FAIL';

export const PRODUCTS_IN_CATEGORY_NEXT = 'PRODUCTS_IN_CATEGORY_NEXT';
export const PRODUCTS_IN_CATEGORY_NEXT_START = 'PRODUCTS_IN_CATEGORY_NEXT_START';
export const PRODUCTS_IN_CATEGORY_NEXT_SUCCESS = 'PRODUCTS_IN_CATEGORY_NEXT_SUCCESS';
export const PRODUCTS_IN_CATEGORY_NEXT_FAIL = 'PRODUCTS_IN_CATEGORY_NEXT_FAIL'

export const PRODUCTS_IN_CATEGORY_PREV = 'PRODUCTS_IN_CATEGORY_PREV';
export const PRODUCTS_IN_CATEGORY_PREV_START = 'PRODUCTS_IN_CATEGORY_PREV_START';
export const PRODUCTS_IN_CATEGORY_PREV_SUCCESS = 'PRODUCTS_IN_CATEGORY_PREV_SUCCESS';
export const PRODUCTS_IN_CATEGORY_PREV_FAIL = 'PRODUCTS_IN_CATEGORY_PREV_FAIL';

export const CLEAR_FILTER = 'CLEAR_FILTER';

export const PRODUCTS_SEARCH = 'PRODUCTS_SEARCH';
export const PRODUCTS_SEARCH_START = 'PRODUCTS_SEARCH_START';
export const PRODUCTS_SEARCH_SUCCESS = 'PRODUCTS_SEARCH_SUCCESS';
export const PRODUCTS_SEARCH_FAIL = 'PRODUCTS_SEARCH_FAIL';

export const PRODUCTS_ID_START = 'PRODUCTS_ID_START';
export const PRODUCTS_ID_SUCCESS = 'PRODUCTS_ID_SUCCESS';
export const PRODUCTS_ID_FAIL = 'PRODUCTS_ID_FAIL';

export const FETCH_PRODUCTS_IN_CATEGORY = 'FETCH_PRODUCTS_IN_CATEGORY';
export const PRODUCTS_IN_CATEGORY_START = 'PRODUCTS_IN_CATEGORY_START';
export const PRODUCTS_IN_CATEGORY_SUCCESS = 'PRODUCTS_IN_CATEGORY_SUCCESS';
export const PRODUCTS_IN_CATEGORY_FAIL = 'PRODUCTS_IN_CATEGORY_FAIL';

export const FETCH_PRODUCTS_IN_DEPARTMENT = 'FETCH_PRODUCTS_IN_DEPARTMENT';
export const PRODUCTS_IN_DEPARTMENT_START = 'PRODUCTS_IN_DEPARTMENT_START';
export const PRODUCTS_IN_DEPARTMENT_SUCCESS = 'PRODUCTS_IN_DEPARTMENT_SUCCESS';
export const PRODUCTS_IN_DEPARTMENT_FAIL = 'PRODUCTS_IN_DEPARTMENT_FAIL';

export const PRODUCT_DETAILS_START = 'PRODUCT_DETAILS_START';
export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS_SUCCESS';
export const PRODUCT_DETAILS_FAIL = 'PRODUCT_DETAILS_FAIL';
export const FETCH_PRODUCT_DETAIL = 'FETCH_PRODUCT_DETAIL';

export const FETCH_PRODUCT_LOCATION = 'FETCH_PRODUCT_LOCATION'; 
export const PRODUCT_LOCATION_START = 'PRODUCT_LOCATION_START';
export const PRODUCT_LOCATION_SUCCESS = 'PRODUCT_LOCATION_SUCCESS';
export const PRODUCT_LOCATION_FAIL = 'PRODUCT_LOCATION_FAIL';

// HERE GOES THE GET & POST FOR REVIEWS //
export const FETCH_PRODUCT_REVIEWS = 'FETCH_PRODUCT_REVIEWS';
export const FETCH_PRODUCT_REVIEWS_START = 'FETCH_PRODUCT_REVIEWS_START';
export const FETCH_PRODUCT_REVIEWS_SUCCESS = 'FETCH_PRODUCT_REVIEWS_SUCCESS';
export const FETCH_PRODUCT_REVIEWS_FAIL = 'FETCH_PRODUCT_REVIEWS_FAIL';

export const POST_PRODUCT_REVIEW = 'POST_PRODUCT_REVIEW'
export const POST_PRODUCT_REVIEW_START = 'POST_PRODUCT_REVIEW_START';
export const POST_PRODUCT_REVIEW_SUCCESS = 'POST_PRODUCT_REVIEW_SUCCESS';
export const POST_PRODUCT_REVIEW_FAIL = 'POST_PRODUCT_REVIEW_FAIL';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCH FOR ORDERS ACTION-TYPES LOGISTIC
export const ORDERS_CONFIRM = 'ORDERS_CONFIRM';

export const CREATE_ORDER = 'CREATE_ORDER';
export const ORDERS_START = 'ORDERS_START';
export const ORDERS_SUCCESS = 'ORDERS_SUCCESS';
export const ORDERS_FAIL = 'ORDERS_FAIL';

export const ORDERS_ID_INIT = 'ORDERS_ID_INIT'; 
export const ORDERS_ID_START = 'ORDERS_ID_START';
export const ORDERS_ID_SUCCESS = 'ORDERS_ID_SUCCESS';
export const ORDERS_ID_FAIL = 'ORDERS_ID_FAIL';

export const ORDERS_IN_CUSTOMER_INIT = 'ORDERS_IN_CUSTOMER_INIT';
export const ORDERS_IN_CUSTOMER_START = 'ORDERS_IN_CUSTOMER_START';
export const ORDERS_IN_CUSTOMER_SUCCESS = 'ORDERS_IN_CUSTOMER_SUCCESS';
export const ORDERS_IN_CUSTOMER_FAIL = 'ORDERS_IN_CUSTOMER_FAIL';

export const ORDERS_SHORT_DETAIL_INIT = 'ORDERS_SHORT_DETAIL_INIT';
export const ORDERS_SHORT_DETAIL_START = 'ORDERS_SHORT_DETAIL_START';
export const ORDERS_SHORT_DETAIL_SUCCESS = 'ORDERS_SHORT_DETAIL_SUCCESS';
export const ORDERS_SHORT_DETAIL_FAIL = 'ORDERS_SHORT_DETAIL_FAIL';

export const ORDERS_ON_CHECKOUT = 'ORDERS_ON_CHECKOUT';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCH FOR SHOPPING CART ACTION-TYPES LOGISTIC
export const GO_TO_SHOPPING_CART = 'GO_TO_SHOPPING_CART';
export const GO_TO_FAVORITES = 'GO_TO_FAVORITES';

export const GENERATE_CART_ID = 'GENERATE_CART_ID';
export const SHOPPING_CART_GENERATE_ID_START = 'SHOPPING_CART_GENERATE_ID_START';
export const SHOPPING_CART_GENERATE_ID_SUCCESS = 'SHOPPING_CART_GENERATE_ID_SUCCESS';
export const SHOPPING_CART_GENERATE_ID_FAIL = 'SHOPPING_CART_GENERATE_ID_FAIL';

export const ADD_PRODUCT_CART = 'ADD_PRODUCT_CART';
export const SHOPPING_CART_ADD_START = 'SHOPPING_CART_ADD_START';
export const SHOPPING_CART_ADD_SUCCESS = 'SHOPPING_CART_ADD_SUCCESS';
export const SHOPPING_CART_ADD_FAIL = 'SHOPPING_CART_ADD_FAIL';

export const SHOPPING_CART_CONFIRM_ADD = 'SHOPPING_CART_CONFIRM_ADD';

export const FETCH_SHOPPING_CART = 'FETCH_SHOPPING_CART';
export const SHOPPING_CART_START = 'SHOPPING_CART_START';
export const SHOPPING_CART_SUCCESS = 'SHOPPING_CART_SUCCESS';
export const SHOPPING_CART_FAIL = 'SHOPPING_CART_FAIL';

export const PUT_UPDATE_PRODUCT = 'PUT_UPDATE_PRODUCT';
export const SHOPPING_CART_UPDATE_PRODUCT = 'SHOPPING_CART_UPDATE_PRODUCT';
export const SHOPPING_CART_UPDATE_PRODUCT_START = 'SHOPPING_CART_UPDATE_PRODUCT_START';
export const SHOPPING_CART_UPDATE_PRODUCT_FAIL = 'SHOPPING_CART_UPDATE_PRODUCT_FAIL';

export const SHOPPING_CART_REMOVE_PRODUCT = 'SHOPPING_CART_REMOVE_PRODUCT';
export const SHOPPING_CART_REMOVE_PRODUCT_START = 'SHOPPING_CART_REMOVE_PRODUCT_START'; 
export const SHOPPING_CART_REMOVE_PRODUCT_SUCCESS = 'SHOPPING_CART_REMOVE_PRODUCT_SUCCESS';
export const SHOPPING_CART_REMOVE_PRODUCT_FAIL = 'SHOPPING_CART_REMOVE_PRODUCT_FAIL'

export const DELETE_SHOPPING_CART = 'DELETE_SHOPPING_CART';
export const SHOPPING_CART_DELETE_START = 'SHOPPING_CART_DELETE_START';
export const SHOPPING_CART_DELETE_SUCCESS = 'SHOPPING_CART_DELETE_SUCCESS';
export const SHOPPING_CART_DELETE_FAIL = 'SHOPPING_CART_DELETE_FAIL';

export const MOVE_TO_CART = 'MOVE_TO_CART';
export const SHOPPING_CART_MOVE_TO_START = 'SHOPPING_CART_MOVE_TO_START';
export const SHOPPING_CART_MOVE_TO_SUCCESS = 'SHOPPING_CART_MOVE_TO_SUCCESS';
export const SHOPPING_CART_MOVE_TO_FAIL = 'SHOPPING_CART_MOVE_TO_FAIL';

export const FETCH_SHOPPING_CART_TOTAL = 'FETCH_SHOPPING_CART_TOTAL';
export const SHOPPING_CART_TOTAL = 'SHOPPING_CART_TOTAL';
export const SHOPPING_CART_TOTAL_FAIL = 'SHOPPING_CART_TOTAL_FAIL';

export const SAVE_FOR_LATER = 'SAVE_FOR_LATER';
export const SHOPPING_CART_SAVE_FAVORITE_START = 'SHOPPING_CART_SAVE_FAVORITE_START';
export const SHOPPING_CART_SAVE_FAVORITE = 'SHOPPING_CART_SAVE_FAVORITE';
export const SHOPPING_CART_SAVE_FAVORITE_FAIL = 'SHOPPING_CART_SAVE_FAVORITE_FAIL';

export const FETCH_SAVE_FAVORITE = 'FETCH_SAVE_FAVORITE';
export const SHOPPING_CART_FETCH_SAVE_FAVORITE_START = 'SHOPPING_CART_FETCH_SAVE_FAVORITE_START';
export const SHOPPING_CART_FETCH_SAVE_FAVORITE_SUCCESS = 'SHOPPING_CART_FETCH_SAVE_FAVORITE_SUCCESS';
export const SHOPPING_CART_FETCH_SAVE_FAVORITE_FAIL = 'SHOPPING_CART_FETCH_SAVE_FAVORITE_FAIL';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCH FOR TAX ACTION-TYPES LOGISTIC
export const FETCH_TAX_INIT = 'FETCH_TAX_INIT';
export const FETCH_TAX = 'FETCH_TAX';
export const FETCH_TAX_FAIL = 'FETCH_TAX_FAIL';

export const TAX_ID_INIT = 'TAX_ID_INIT';
export const TAX_ID = 'TAX_ID';
export const TAX_ID_FAIL = 'TAX_ID_FAIL';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// FETCH FOR SHIPPING ACTION-TYPES LOGISTIC
export const SHIPMENT_AVAILABLE = 'SHIPMENT_AVAILABLE';
export const FETCH_SHIPPING = 'FETCH_SHIPPING';
export const FETCH_SHIPPING_FAIL = 'FETCH_SHIPPING_FAIL';

export const SHIPPING_OPTIONS = 'SHIPPING_OPTIONS';
export const SHIPPING_ID_START = 'SHIPPING_ID_START';
export const SHIPPING_ID_SUCCESS = 'SHIPPING_ID_SUCCESS';
export const SHIPPING_ID_FAIL = 'SHIPPING_ID_FAIL';

 //–––––––––––––––––––––––––––––––––––––––––––––––––––––––––
// ACTION-TYPES LOGISTIC FOR THE STRIPE API
export const STRIPE_CHARGE_INIT = 'STRIPE_CHARGE_INIT'; 
export const STRIPE_CHARGE_START = 'STRIPE_CHARGE_START';
export const STRIPE_CHARGE_SUCCESS = 'STRIPE_CHARGE_SUCCESS';
export const STRIPE_CHARGE_FAIL = 'STRIPE_CHARGE_FAIL';

export const STRIPE_WEBHOOKS_INIT = 'STRIPE_WEBHOOKS_INIT';
export const STRIPE_WEBHOOKS_START = 'STRIPE_WEBHOOKS_START';
export const STRIPE_WEBHOOKS_SUCCESS = 'STRIPE_WEBHOOKS_SUCCESS';
export const STRIPE_WEBHOOKS_FAIL = 'STRIPE_WEBHOOKS_FAIL';

export const CONFIRM_CHARGE_RECEIVED_STRIPE = 'CONFIRM_CHARGE_RECEIVED_STRIPE';